import { LatLng } from '@/types/google/geometry';

const CACHE_KEY = 'paire_location_cache';
const CACHE_DURATION = 30 * 24 * 60 * 60 * 1000; // 30 days in milliseconds

interface LocationCache {
  position: LatLng;
  timestamp: number;
}

export const getLocationFromCache = (): LatLng | null => {
  if (process.env.NODE_ENV !== 'development') {
    return null;
  }

  try {
    const cached = localStorage.getItem(CACHE_KEY);
    if (!cached) {
      return null;
    }

    const data: LocationCache = JSON.parse(cached);
    const now = Date.now();

    // Check if cache is expired (30 days)
    if (now - data.timestamp > CACHE_DURATION) {
      localStorage.removeItem(CACHE_KEY);
      return null;
    }

    console.debug('Using cached location data:', data.position);
    return data.position;
  } catch (error) {
    console.error('Error reading location cache:', error);
    return null;
  }
};

export const saveLocationToCache = (position: LatLng): void => {
  if (process.env.NODE_ENV !== 'development') {
    return;
  }

  try {
    const cache: LocationCache = {
      position,
      timestamp: Date.now()
    };

    localStorage.setItem(CACHE_KEY, JSON.stringify(cache));
    console.log('Location cached for development:', position);
  } catch (error) {
    console.error('Error saving location to cache:', error);
  }
};

export const clearLocationCache = (): void => {
  try {
    localStorage.removeItem(CACHE_KEY);
    console.log('Location cache cleared');
  } catch (error) {
    console.error('Error clearing location cache:', error);
  }
};